import { useContext, useEffect } from "react"
import { ConfigurationContext } from "../../context/configurationContext";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import * as apiService from '../../../api'
import { useSelector } from "react-redux";

const InterceptorDispositivoSeguro = ({ children }) => {
  const { setIdDispositivo,setListaDispositivoSeguro } = useContext(ConfigurationContext);
  const infoAfiliado = useSelector((state) => state.afiliado.infoAfiliado);

  useEffect(async () => {
    const fpPromise = FingerprintJS.load()
    const fp = await fpPromise
    const result = await fp.get()
    setIdDispositivo(result.visitorId)

    const response = await apiService.autentificacion.getDispositivosSegurosDeAfiliado(infoAfiliado.codigoAfiliado)
    setListaDispositivoSeguro(response.data.result.dispositivosSeguros) 
    },[])


    return children
}

export default InterceptorDispositivoSeguro